import { useNavigate } from 'react-router-dom';

import { OrdersTable, useOrdersTableDataQuery } from '~widgets/orders-table';

import Button from '@breeze-platform-ui/button';
import { Int24Plus } from '@breeze-platform-ui/iconsPack';

import { OrdersLayout } from './ui/layout';

export { CreateOrderPage } from './create';

export const OrdersPage = () => {
  const { data } = useOrdersTableDataQuery({ page: 0, perPage: 8 });
  const navigate = useNavigate();

  return (
    <OrdersLayout
      title={
        <div className="mb-10 flex w-full items-center justify-between">
          <h2 className="my-0 text-4xl font-bold">Orders</h2>
          {!!data?.total && (
            <Button
              size="m"
              icon={<Int24Plus />}
              href="/orders/create"
              onClick={(e) => {
                e.preventDefault();
                navigate('/orders/create');
              }}
            >
              Add order
            </Button>
          )}
        </div>
      }
    >
      <OrdersTable />
    </OrdersLayout>
  );
};
